jQuery(function($) {
    setTimeout(function() {
        $('.fun_slider').owlCarousel({
            items: 1,
            loop: true,
            dots: false,
            nav: true,
            mouseDrag: true,
            touchDrag: true,
            margin: 0,
        });
    }, 100);
});